<div *ngIf='componentReady' [formGroup]='inputForm' class='ForwardDialog'>
  <div class='row'>
    <div class='col col-12'>
      <mat-radio-group
        (change)='onForwardChange($event)'
        formControlName='forward_type'>
        <mat-radio-button [value]='forwardTypes.ACCOUNT' class='me-2'>To your default account email</mat-radio-button>
        <mat-radio-button
          [value]='forwardTypes.RECIPIENTS'
          class='mt-3'
        >Specify an email address
        </mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
  <div *ngIf='forwardType.value === forwardTypes.RECIPIENTS' class='row mt-3'>
    <app-text-field formControlName='recipients'></app-text-field>
  </div>
  <div class='row mt-3'>
    <mat-checkbox formControlName='contact_details'>Include contact details</mat-checkbox>
  </div>
</div>